var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoorClosedSvgrepocom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.95068 20.6551H20.6556M17.7048 20.6551V6.09774C17.7048 4.996 17.7048 4.44512 17.4904 4.02431C17.3018 3.65415 17.0008 3.35321 16.6307 3.16461C16.2099 2.9502 15.659 2.9502 14.5572 2.9502H9.04904C7.94731 2.9502 7.39643 2.9502 6.97562 3.16461C6.60546 3.35321 6.30452 3.65415 6.11592 4.02431C5.9015 4.44512 5.9015 4.996 5.9015 6.09774V20.6551M14.754 11.8027H14.7638",
    stroke: "#9393B0",
    strokeWidth: 1.96721,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoorClosedSvgrepocom);
export default __webpack_public_path__ + "static/media/door-closed_svgrepo.com.527966fafc7c80e7cc3b83da2cc57c54.svg";
export { ForwardRef as ReactComponent };